// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__fwDg-","list":"BalanceDue_list__aKGkp","listRow":"BalanceDue_listRow__1pqX9","total":"BalanceDue_total__1jUhr"};